module.exports = __webpack_public_path__ + "fonts/calibri-regular.baf2d27a.ttf";